// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"66c9ce1f","422":"632efea6"}[chunkId] + ".chunk.js";
};